module.exports = __webpack_public_path__ + "static/img/til64.c32bf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til64.png
// module id = VDkp
// module chunks = 1